import { AvailableDevicesService } from "@/common/api.service";
import { FETCH_AVAILABLE_ADMIN_DEVICE, RESET_STATE } from "./actions.type";
import { SET_ADMIN_DEVICES_DATA, SET_ADMIN_DEVICES_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    admindevicedata: [],
    admindeviceerror: [],
  }
};

export const state = initialState();

const actions = {

  async [FETCH_AVAILABLE_ADMIN_DEVICE](context, slug) {
    return await AvailableDevicesService.get(slug).then(response => {
      context.commit(SET_ADMIN_DEVICES_DATA, response.data)
      return response.data
    }).catch(({ response }) => {
      context.commit(SET_ADMIN_DEVICES_ERROR, response.data.errorMessage)
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_ADMIN_DEVICES_DATA](state, admindevicedata) {
    state.admindevicedata = admindevicedata
  },
  [SET_ADMIN_DEVICES_ERROR](state, error) {
    state.admindeviceerror = error
  },
  [STATE_RESET](state) {
    Object.assign(state, initialState())
  }

}

const getters = {

  admindevicedata(state) {
    return state.admindevicedata;
  },

}

export default {
  state,
  getters,
  actions,
  mutations
};
